import { Header4, Title4, Body2 } from 'components/Typography';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import Image from 'next/image';
import { getStaticAssetUrl } from 'utils/url';
import React, { useState } from 'react';
import { formatUsd } from '@dapp/multi-lib/lib/formatters';
import { useTranslation } from 'react-i18next';
import { useConnection } from 'wagmi';
import { cx } from 'class-variance-authority';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';

export const UserTotalBalance = (props: { balance: string }) => {
  const { balance } = props;
  const connection = useConnection();
  const { t } = useTranslation('common');
  const [isVisible, setIsVisible] = useState(true);
  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const csr = useClientRenderDelay();

  if (!csr) {
    return null;
  }

  return (
    <div className='flex flex-col items-start gap-2 self-start'>
      <Title4 className='text-[1rem] font-thin leading-[1rem] text-[#B5B5B5] lg:text-[1.25rem] lg:leading-[1.25rem]'>
        {t('BALANCE')}:
      </Title4>
      <div className='flex items-center gap-2'>
        <Header4 className='text-[1.625rem] leading-[1.625rem] text-white lg:text-[2.25rem] lg:leading-[2.25rem]'>
          {isVisible ? `$${formatUsd(balance)}` : '$****'}
        </Header4>
        {!isVisible ? (
          <Icon
            icon='eye_open'
            color={'#B5B5B5'}
            width={22}
            height={22}
            className='cursor-pointer'
            onClick={toggleVisibility}
          />
        ) : (
          <Image
            src={getStaticAssetUrl('/sfi/static/pv2/visibility-off.svg')}
            alt='visibilityoff'
            width={20}
            height={20}
            className='cursor-pointer '
            onClick={toggleVisibility}
          />
        )}
      </div>
      <Body2
        className={cx('text-[#EDFF6D]', {
          hidden: connection.isConnected,
        })}
      >
        {t('CONNECT_WALLET_DESCRIPTION')}
      </Body2>
    </div>
  );
};
